import styled from "styled-components";

export const PremiumPubInfoReportWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 77px;
  gap: 10px;

  > img {
    width: 70px;
    height: 70px;
  }

  > .name {
    font-weight: 700;
    font-size: 13px;
    text-align: center;
  }
`;

export const PremiumPubInfoReportButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d918181a;
  height: 42px;
  border-radius: 8px;
  width: 140px;
  gap: 6px;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  color: #d91818;
`;
